import React, { useEffect, useRef, useState } from "react";
import MaterialTable from "material-table";
import moment from "moment";
import Select from "react-select";

// reactstrap components
import {
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Form,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

// style
import { table_translate } from "../../constants/MaterialTable.js";

// helpers
import { formateDateApi } from "../../helpers/formats";

// services
import { showMessage, showQuestion } from "../../services/message.js";
import { api_GET, api_POST } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "services/acesso.js";

//Views
import FichaRequerimentoTransportador from "../../views/Shared/Transportador/FichaRequerimento";
import FichaRequerimentoGerador from "../../views/Shared/Gerador/FichaRequerimento";
import FichaRequerimentoDestino from "../../views/Shared/Destino/FichaRequerimento";

//Context
import { useAuth } from "../../context/auth.js";

export default function AcompanhamentoLista({ requerimentos, handleReturn }) {
  const { session, setLoading } = useAuth();

  const [list_table, set_list_table] = useState([]);

  const [tipoAcao, setTipoAcao] = useState(null);

  //State para pegar o requerimento
  const [item_requerimento, set_item_requerimento] = useState(null);

  //State para manipular checkbox na tabela
  const [selection, set_selection] = useState({
    selection: false,
    filtering: true,
  });

  //State para pegar os requerimentos para publicação
  const [requerimentos_publicacao, set_requerimentos_publicacao] = useState([]);

  //State para pegar lista de lote para publicação
  const [listLotePublicacao, setListLotePublicacao] = useState([]);

  //State para pegar a data de publicação do lote
  const [dataPublicacao, setDataPublicacao] = useState(null);

  //State para pegar lista de lote para cancelamento
  const [listLoteCancelamento, setListLoteCancelamento] = useState([]);

  // State para pegar a permissão de cancelar requerimentos
  const [permissaoCancelarRequerimentos, setPermissaoCancelarRequerimentos] =
    useState(false);

  // State para setar o número de registros por página
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const formateDate = (date) => {
    return moment(date).format("DD/MM/YYYY");
  };

  const calcularStatusDocumentacao = (rowData) => {
    const docs = rowData.requerimentoDocumento || rowData.requerimentoDocumentos || [];
    const veiculos = rowData?.requerimentoTransportadorVeiculo || [];

    if (docs.some(d => d.statusAnalise === 'Reprovado')) return "Reprovado";

    for (const veiculo of veiculos) {
      if (veiculo.statusAnaliseComprovanteTara === 'Reprovado' ||
        veiculo.statusAnaliseInspecaoInmetro === 'Reprovado' ||
        veiculo.statusAnaliseRenavam === 'Reprovado') {
        return "Reprovado";
      }
    }

    const todosDocumentosAprovados = docs.length > 0 && docs.every(d => d.statusAnalise === 'Aprovado' || d.statusAnalise === 'Análise Manual');

    const todosVeiculosAprovados = veiculos.length === 0 || veiculos.every(v =>
      (!v.statusAnaliseComprovanteTara || v.statusAnaliseComprovanteTara === 'Aprovado' || v.statusAnaliseComprovanteTara === 'Análise Manual') &&
      (!v.statusAnaliseInspecaoInmetro || v.statusAnaliseInspecaoInmetro === 'Aprovado' || v.statusAnaliseInspecaoInmetro === 'Análise Manual') &&
      (!v.statusAnaliseRenavam || v.statusAnaliseRenavam === 'Aprovado' || v.statusAnaliseRenavam === 'Análise Manual')
    );

    if (todosDocumentosAprovados && todosVeiculosAprovados)
      return "Aprovado";

    return "Reprovado";
  };

  const calcularDocumentosAprovados = (rowData) => {
    const docs = rowData.requerimentoDocumento || rowData.requerimentoDocumentos || [];
    const veiculos = rowData?.requerimentoTransportadorVeiculo || [];

    const totalDocs = docs.length;
    const aprovadosDocs = docs.filter(d => d.statusAnalise === 'Aprovado' || d.statusAnalise === 'Análise Manual').length;

    let totalVeiculoDocs = 0;
    let aprovadosVeiculoDocs = 0;

    if (veiculos.length > 0) {
      veiculos.forEach(v => {
        if (v.statusAnaliseComprovanteTara) {
          totalVeiculoDocs++;
          if (v.statusAnaliseComprovanteTara === 'Aprovado' || v.statusAnaliseComprovanteTara === 'Análise Manual') aprovadosVeiculoDocs++;
        }
        if (v.statusAnaliseInspecaoInmetro) {
          totalVeiculoDocs++;
          if (v.statusAnaliseInspecaoInmetro === 'Aprovado' || v.statusAnaliseInspecaoInmetro === 'Análise Manual') aprovadosVeiculoDocs++;
        }
        if (v.statusAnaliseRenavam) {
          totalVeiculoDocs++;
          if (v.statusAnaliseRenavam === 'Aprovado' || v.statusAnaliseRenavam === 'Análise Manual') aprovadosVeiculoDocs++;
        }
      });
    }

    const total = totalDocs + totalVeiculoDocs;
    const aprovados = aprovadosDocs + aprovadosVeiculoDocs;

    return `(${aprovados}/${total})`;
  };

  const calcularDocumentosAnaliseManual = (rowData) => {
    const docs = rowData.requerimentoDocumento || rowData.requerimentoDocumentos || [];
    const veiculos = rowData?.requerimentoTransportadorVeiculo || [];

    const manualDocs = docs.filter(d => d.statusAnalise === 'Análise Manual').length;

    let manualVeiculoDocs = 0;

    if (veiculos.length > 0) {
      veiculos.forEach(v => {
        if (v.statusAnaliseComprovanteTara === 'Análise Manual') manualVeiculoDocs++;
        if (v.statusAnaliseInspecaoInmetro === 'Análise Manual') manualVeiculoDocs++;
        if (v.statusAnaliseRenavam === 'Análise Manual') manualVeiculoDocs++;
      });
    }

    return manualDocs + manualVeiculoDocs;
  };

  //State para colocar os campos na tabela
  const [listaColumn, setListaColumn] = useState([
    {
      title: "Ações",
      field: "internal_action",
      filtering: false,
      editable: "never",
      render: (rowData) =>
        rowData && (
          <div>
            <i
              className="fas fa-search"
              style={{ cursor: "pointer" }}
              onClick={(e) => handleVisualizarRequerimento(rowData)}
            ></i>
            {requerimentos[0]?.fluxoCadastroEtapaAtual?.tipo ==
              "Aguardando Diário Oficial" &&
              rowData?.requerimentoSolicitacaoPublicacaoDiarioOficiais[0]
                ?.status == "Falha" && (
                <i
                  className="fas fa-circle-notch"
                  style={{ cursor: "pointer", marginLeft: "20px" }}
                  onClick={() =>
                    handlePublicaoLoteRefresh(rowData?.requerimento_Id)
                  }
                ></i>
              )}
          </div>
        ),
    },
    {
      title: "Número Requerimento",
      field: "numeroRequerimento",
      editable: "never",
      filtering: true,
    },
    requerimentos[0]?.excluirRequerimento
      ? {
        title: "Modalidade",
        field: "setupSolicitacaoAcao.setupSolicitacao.categoria.segmento",
        editable: "never",
        filtering: true,
      }
      : [],
    {
      title: "Categoria",
      field: "setupSolicitacaoAcao.setupSolicitacao.categoria.descricao",
      editable: "never",
      filtering: true,
    },
    {
      title: "Etapa",
      field: "fluxoCadastroEtapaAtual.tipo",
      editable: "never",
      filtering: true,
    },
    requerimentos[0]?.excluirRequerimento
      ? {
        title: "Tipo",
        field: "setupSolicitacaoAcao.acao",
        editable: "never",
        filtering: true,
      }
      : [],
    {
      title: "Data da Solicitação",
      field: "dataCriacaoRequerimento",
      render: (rowData) => formateDate(rowData.dataCriacaoRequerimento),
      editable: "never",
      filtering: true,
      customFilterAndSearch: (filter, rowData) =>
        moment(rowData.dataCriacaoRequerimento)
          .format("DD/MM/YYYY")
          .includes(filter),
    },
    {
      title: "Última Ação",
      field: "dataUltimaAcao",
      render: (rowData) =>
        rowData.dataUltimaAcao ? formateDate(rowData.dataUltimaAcao) : "",
      editable: "never",
      filtering: true,
      customFilterAndSearch: (filter, rowData) =>
        rowData.dataUltimaAcao
          ? moment(rowData.dataUltimaAcao).format("DD/MM/YYYY").includes(filter)
          : false,
    },
    {
      title: "CNPJ/CPF",
      field: "protocolo.cpf_Cnpj",
      editable: "never",
      filtering: true,
    },
    {
      title: "Solicitante",
      field: "protocolo.nomeSolicitante",
      editable: "never",
      filtering: true,
    },
  ]);

  //State para pegar lista de lote para analise de requerimento
  const [listLoteAguardadoAnaliseRGG, setListLoteAguardadoAnaliseRGG] =
    useState([]);

  //State para pegar o enquandramento
  const [enquadramento, set_enquadramento] = useState(null);

  const [modalLotePublicacao, setModalLotePublicacao] = useState(false);

  const toggleLotePublicacao = () => {
    setModalLotePublicacao(!modalLotePublicacao);
    setDataPublicacao(null);
  };

  //State para abrir modal
  const [modalEnquadramento, setModalEnquadramento] = useState(false);

  const toggleEnquadramento = () => setModalEnquadramento(!modalEnquadramento);

  const ref = useRef(null);

  const [options_enquadramento, set_options_enquadramento] = useState([]);
  const loadOptionsEnquadramento = () => {
    api_GET("enquadramento")
      .then((result) => set_options_enquadramento(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleModal = () => {
    if (
      tipoAcao?.tipo === "Aguardando Análise"
    ) {
      handleLoteAguardandoAnalise(true);
      return;
    }
    if (
      tipoAcao?.tipo == "Publicar Diário Oficial" &&
      requerimentos_publicacao.length > 0
    ) {
      //pegar todos os requerimentos sem enquadramentos
      let json_submit = [];
      requerimentos_publicacao
        .filter((x) => x.protocolo.enquadramento_Id == null)
        .map((item) => {
          json_submit.push({
            requerimento_Id: item.requerimento_Id,
            Enquadramento_Id: enquadramento.enquadramento_Id,
          });
        });

      setLoading(true);
      api_POST("AnaliseRequerimento/PostEnquadramentos", json_submit)
        .then((result) => {
          toggleEnquadramento();
          handlePublicarDiarioOficial();
        })
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    }
  };

  const handlePublicarDiarioOficial = () => {
    if (
      enquadramento == null &&
      requerimentos_publicacao.length > 0 &&
      requerimentos_publicacao.filter(
        (x) => x.protocolo.enquadramento_Id == null
      ).length > 0
    ) {
      toggleEnquadramento();
      return;
    }

    let json_submit = {
      laudaDiarioOficial_Id: 0,
      dataPublicacao: formateDateApi(new Date()),
      usuario_Id: session.usuario_Id,
      requerimentoLaudaDiarioOficial: requerimentos_publicacao,
    };

    setLoading(true);
    api_POST("AnaliseRequerimento/PostLaudaDiarioOficial", json_submit)
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleEmitirGuia = () => {
    let json_submit = [];
    for (var i in requerimentos_publicacao) {
      json_submit.push({
        requerimento_Id: requerimentos_publicacao[i].requerimento_Id,
        usuarioEmissao_Id: session.usuario_Id,
      });
    }

    setLoading(true);
    api_POST("AnaliseRequerimento/PostRequerimentoCobrancaLote", json_submit)
      .then((result) =>
        showMessage("Aviso", result.data, "success", function () {
          handleReturn();
        })
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleVisualizarRequerimento = (rowData) => {
    setLoading(true);
    api_GET("requerimento/" + rowData.requerimento_Id)
      .then((result) => set_item_requerimento(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleChange = (e) => {
    set_enquadramento(e);
  };

  const handlePublicarDiarioLote = () => {
    if (dataPublicacao == null) {
      showMessage(
        "Aviso",
        "Por favor, selecione a data de publicação.",
        "warning",
        null
      );
      return;
    }

    if (listLotePublicacao.length == 0) {
      showMessage(
        "Aviso",
        "Por favor, selecione algum requerimento.",
        "warning",
        null
      );
      return;
    }

    if (listLotePublicacao.length > 10) {
      showMessage(
        "Aviso",
        "Selecione apenas 10 registros por vez",
        "warning",
        null
      );
      return;
    }

    let json_submit = [];

    listLotePublicacao.map((req) => {
      json_submit.push({
        requerimentoSolicitacaoPublicacaoDiarioOficial_Id: 0,
        requerimento_Id: req.requerimento_Id,
        status: "Solicitado",
        dataPublicacao: moment(dataPublicacao).format("YYYY-MM-DD"),
        usuarioPublicacao_Id: session.usuario_Id,
      });
    });

    toggleLotePublicacao();

    setLoading(true);
    api_POST(
      "AnaliseRequerimento/PostRequerimentoSolicitacaoPublicacaoDiarioOficial",
      json_submit
    )
      .then((result) =>
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        )
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handlePublicaoLoteRefresh = (requerimento_Id) => {
    setLoading(true);
    api_POST(
      "AnaliseRequerimento/PostProcessaPublicacaoDiarioOficial/" +
      requerimento_Id
    )
      .then((result) =>
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        )
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleAcaoSectionTable = (allRows, selectedRow) => {
    let rows = allRows;

    if (tipoAcao?.tipo === "Aguardando Análise") {
      rows = allRows.filter((r) => calcularStatusDocumentacao(r) === "Aprovado" && calcularDocumentosAnaliseManual(r) === 0);
    }

    if (tipoAcao.excluirRequerimento) {
      setListLoteCancelamento(rows);
    } else if (
      tipoAcao.tipo === "Aguardando Análise"
    ) {
      if (rows?.length > 10) {
        showMessage(
          "Aviso",
          "Selecione apenas 10 registros por vez",
          "warning",
          null
        );
        return;
      }
      setListLoteAguardadoAnaliseRGG(rows);
    } else if (
      tipoAcao.tipo == "Emissão de Guia" ||
      tipoAcao.tipo == "Publicar Diário Oficial"
    ) {
      set_requerimentos_publicacao(rows);
    } else if (tipoAcao.tipo == "Aguardando Diário Oficial") {
      setListLotePublicacao(
        rows.filter(
          (x) => x?.requerimentoSolicitacaoPublicacaoDiarioOficiais?.length == 0
        )
      );
    }

    set_list_table((prev) => {
      return prev?.map((m) => {
        if (rows.some((r) => r.tableData.id == m.tableData.id)) {
          m.tableData.checked = true;
        } else {
          m.tableData.checked = false;
        }
        return m;
      });
    });
  };

  const handleLoteAguardandoAnalise = (aprovacao) => {
    if (listLoteAguardadoAnaliseRGG.length > 10) {
      showMessage(
        "Aviso",
        "Por favor, selecione no máximo 10 requisições.",
        "warning",
        null
      );
      return;
    }
    if (listLoteAguardadoAnaliseRGG.length == 0) {
      showMessage("Aviso", "Selecione os requerimento(s).", "warning", null);
      return;
    }

    if (
      enquadramento == null &&
      aprovacao == true &&
      listLoteAguardadoAnaliseRGG.some(
        (x) => x.setupSolicitacaoAcao.enquadramentoObrigatorio == true
      )
    ) {
      toggleEnquadramento();
      return;
    }

    let listaRequerimentos = [];

    listLoteAguardadoAnaliseRGG.forEach(({ requerimento_Id }) => {
      listaRequerimentos.push({
        requerimentoAnaliseGestor_Id: 0,
        requerimento_Id: requerimento_Id,
        dataAnalise: formateDateApi(new Date()),
        usuarioAnalise_Id: session.usuario_Id,
        enquadramento_Id: enquadramento?.enquadramento_Id ?? null,
        aceite: aprovacao,
      });
    });

    const mensagemConfirmacao = aprovacao
      ? "Confirma a aprovação de todos os requerimentos selecionados?"
      : "Confirma a reprovação de todos os requerimentos selecionados?";

    showQuestion(
      "Aviso",
      mensagemConfirmacao,
      "question",
      function (retorno) {
        if (retorno) {
          setLoading(true);
          api_POST(
            "AnaliseRequerimento/PostRequerimentosLoteAnaliseGestor",
            listaRequerimentos
          )
            .then((result) => {
              if (
                result.data?.length > 0 &&
                result.data?.filter((x) => x.requerimentoAnaliseGestor_Id == 0)
                  .length > 0
              ) {
                let requerimentos_IDs = result.data
                  ?.filter((x) => x.requerimentoAnaliseGestor_Id == 0)
                  .map(({ requerimento_Id }) => requerimento_Id);
                let requerimentosFalha = listLoteAguardadoAnaliseRGG
                  .filter((x) => requerimentos_IDs.includes(x.requerimento_Id))
                  .map(({ numeroRequerimento }) => numeroRequerimento);

                showMessage(
                  "Error",
                  `Alguns requerimentos falharam:  (${requerimentosFalha?.join(
                    ", "
                  )}). Por favor, verifique cada um individualmente.`,
                  "warning",
                  () => handleReturn()
                );
              } else
                showMessage("Sucesso", "Sucesso na operação.", "success", () =>
                  handleReturn()
                );
            })
            .catch((err) => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
        }
      }
    );
  };

  const handleCancelarRequerimentos = () => {
    showQuestion(
      "Aviso",
      "Tem certeza que deseja cancelar os requerimentos? Esta ação é irreversível",
      "question",
      function (retorno) {
        if (retorno) {
          let listaRequerimentos = [];

          listLoteCancelamento.forEach(({ requerimento_Id, protocolo_Id }) => {
            listaRequerimentos.push({
              requerimento_Id: requerimento_Id,
              usuarioCancelamento_Id: session.usuario_Id,
              protocolo_Id: protocolo_Id,
            });
          });

          setLoading(true);
          api_POST(
            "requerimento/CancelamentoLoteRequerimentos",
            listaRequerimentos
          )
            .then((result) => {
              showMessage(
                "Aviso",
                "Operação executada com sucesso!",
                "success",
                null
              );
              handleReturn();
            })
            .catch((err) => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
        }
      }
    );
  };

  useEffect(() => {
    if (ref) {
      ref.current.scrollIntoView();
    }

    ValidaAcessoFuncionalidadeAcao(
      "AnaliseRequerimento.Editar",
      function (result) {
        setPermissaoCancelarRequerimentos(result);
      }
    );

    const _tipoAcao = {
      tipo: requerimentos[0].fluxoCadastroEtapaAtual.tipo,
      sigla:
        requerimentos[0]?.setupSolicitacaoAcao?.setupSolicitacao?.categoria
          ?.sigla,
      segmento:
        requerimentos[0]?.setupSolicitacaoAcao?.setupSolicitacao?.segmento,
      excluirRequerimento: requerimentos[0]?.excluirRequerimento,
    };

    setTipoAcao({ ..._tipoAcao });
    set_list_table(requerimentos);

    if (
      _tipoAcao.tipo === "Publicar Diário Oficial" ||
      _tipoAcao.excluirRequerimento === true
    ) {
      set_selection({ ...selection, selection: true });
    } else if (_tipoAcao.tipo == "Emissão de Guia") {
      set_selection({ ...selection, selection: true });
      setListaColumn([
        ...listaColumn,
        {
          filtering: true,
          title: "Quantidade de Boletos",
          field: "requerimentoCobrancas",
          editable: "never",
          render: (rowData) =>
            rowData.requerimentoCobrancas.length > 0
              ? rowData.requerimentoCobrancas.length
              : 0,
          customFilterAndSearch: (filter, rowData) =>
            rowData.requerimentoCobrancas.length.toString().includes(filter),
        },
      ]);
    } else if (_tipoAcao.tipo === "Aguardando Diário Oficial") {
      set_selection({
        ...selection,
        selection: true,
        selectionProps: (rowData) => ({
          style: {
            visibility: rowData
              ?.requerimentoSolicitacaoPublicacaoDiarioOficiais[0]?.status
              ? "hidden"
              : "visible",
          },
          disabled: rowData?.requerimentoSolicitacaoPublicacaoDiarioOficiais[0]
            ?.status
            ? true
            : false,
        }),
      });
      setListaColumn([
        ...listaColumn,
        {
          filtering: true,
          title: "Status Processamento",
          field: "status",
          render: (rowData) =>
            rowData.requerimentoSolicitacaoPublicacaoDiarioOficiais[0]
              ?.status ?? null,
          editable: "never",
          customFilterAndSearch: (filter, rowData) => {
            const status =
              rowData.requerimentoSolicitacaoPublicacaoDiarioOficiais[0]
                ?.status ?? "";
            return status.toLowerCase().includes(filter.toLowerCase());
          },
        },
      ]);
    } else if (_tipoAcao.tipo === "Aguardando Análise") {
      set_selection({
        ...selection,
        selection: true,
        selectionProps: (rowData) => {
          const isAprovado = calcularStatusDocumentacao(rowData) === "Aprovado";
          const temManual = calcularDocumentosAnaliseManual(rowData) > 0;
          const liberadoParaLote = isAprovado && !temManual;
          return {
            style: {
              visibility: liberadoParaLote ? "visible" : "hidden",
            },
            disabled: !liberadoParaLote,
          };
        },
      });
      setListaColumn([
        ...listaColumn,
        {
          title: "Status Documentação",
          field: "statusDocumentacao",
          editable: "never",
          render: calcularStatusDocumentacao
        },
        {
          title: "Documentos Aprovados",
          field: "documentosAprovados",
          editable: "never",
          render: calcularDocumentosAprovados
        },
        {
          title: "Análise Manual",
          field: "analiseManual",
          editable: "never",
          render: calcularDocumentosAnaliseManual
        }
      ]);
    }
    loadOptionsEnquadramento();
  }, []);

  return (
    <>
      {modalEnquadramento && (
        <Modal isOpen={modalEnquadramento} toggle={toggleEnquadramento}>
          <ModalHeader toggle={toggleEnquadramento}>Enquadramento</ModalHeader>
          <ModalBody>
            <b style={{ margin: "10px 0" }}>
              Selecione o Enquadramento para aplicar ao(s) requerimento(s)
              selecionado(s).
            </b>
            <Form>
              <Select
                options={options_enquadramento}
                name="enquadramento"
                getOptionLabel={(option) => option.descricao}
                getOptionValue={(option) => option.enquadramento_Id}
                onChange={(e) => {
                  handleChange(e);
                }}
                value={
                  enquadramento != null &&
                  options_enquadramento.find(
                    (obj) =>
                      obj.enquadramento_Id === enquadramento.enquadramento_Id
                  )
                }
                placeholder="Selecione"
              />
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={handleModal}>
              {tipoAcao?.tipo === "Aguardando Análise" ? "Aprovar" : "Salvar"}
              <i className="far fa-save" style={{ marginLeft: "5px" }}></i>
            </Button>
            <Button color="secondary" onClick={toggleEnquadramento}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {modalLotePublicacao && (
        <Modal isOpen={modalLotePublicacao} toggle={toggleLotePublicacao}>
          <ModalHeader toggle={toggleLotePublicacao}>
            Data de Publicação
          </ModalHeader>
          <ModalBody>
            <Form>
              <Input
                type="date"
                name="date"
                id="DataPublicacao"
                onChange={(e) => setDataPublicacao(e.target.value)}
              />
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={handlePublicarDiarioLote}>
              Confirmar <i class="far fa-save"></i>
            </Button>
          </ModalFooter>
        </Modal>
      )}

      <div className="content">
        {item_requerimento == null && (
          <div className="contentTable" ref={ref}>
            <Button color="secondary" onClick={handleReturn}>
              <i class="fas fa-chevron-left"></i> VOLTAR
            </Button>
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="12">
                    <MaterialTable
                      style={{ minHeight: "auto" }}
                      title="Requerimentos"
                      columns={listaColumn}
                      data={list_table}
                      isLoading={false}
                      options={selection}
                      onSelectionChange={(rows, selectedRow) => {
                        handleAcaoSectionTable(
                          rows.filter((r, i) => i < rowsPerPage),
                          selectedRow
                        );
                      }}
                      onChangeRowsPerPage={(_rows) => setRowsPerPage(_rows)}
                      localization={table_translate}
                      cellEditable={{
                        onCellEditApproved: (
                          newValue,
                          oldValue,
                          rowData,
                          columnDef
                        ) => {
                          return new Promise((resolve, reject) => {
                            setTimeout(resolve, 1000);
                          });
                        },
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  {tipoAcao &&
                    tipoAcao.tipo === "Aguardando Análise" && (
                      <Col lg="12">
                        <Button
                          color="success"
                          onClick={() => handleLoteAguardandoAnalise(true)}
                          className="btn-mobile"
                          type="button"
                        >
                          Aprovar Requerimentos em Lote
                        </Button>
                      </Col>
                    )}
                  {tipoAcao && tipoAcao.tipo == "Publicar Diário Oficial" && (
                    <Col lg="12">
                      <Button
                        color="info"
                        onClick={handlePublicarDiarioOficial}
                      >
                        <i class="fas fa-file-export"></i> Publicár Diário
                        Oficial
                      </Button>
                    </Col>
                  )}
                  {tipoAcao && tipoAcao.tipo == "Emissão de Guia" && (
                    <Col lg="12">
                      <Button color="secondary" onClick={handleEmitirGuia}>
                        Emitir Guias
                      </Button>
                    </Col>
                  )}
                  {tipoAcao &&
                    tipoAcao.tipo == "Aguardando Diário Oficial" &&
                    requerimentos?.filter(
                      (x) =>
                        x?.requerimentoSolicitacaoPublicacaoDiarioOficiais
                          ?.length == 0
                    ).length && (
                      <Col lg="12">
                        <Button
                          color="primary"
                          onClick={() => {
                            if (
                              listLotePublicacao.length == 0 &&
                              list_table.filter(
                                (x) =>
                                  x
                                    ?.requerimentoSolicitacaoPublicacaoDiarioOficiais
                                    ?.length == 0
                              ).length > 0
                            ) {
                              showMessage(
                                "Aviso",
                                "Por favor, selecione algum requerimento para fazer a publicação de lote.",
                                "warning",
                                null
                              );
                              return;
                            }
                            if (
                              list_table.length ===
                              list_table.filter(
                                (x) =>
                                  x
                                    ?.requerimentoSolicitacaoPublicacaoDiarioOficiais
                                    ?.length > 0
                              ).length
                            ) {
                              showMessage(
                                "Aviso",
                                "Não existe requerimento para ser feito a publicação em lote.",
                                "warning",
                                null
                              );
                              return;
                            }
                            if (listLotePublicacao.length > 0)
                              setModalLotePublicacao(true);
                          }}
                        >
                          Publicação em Lote
                        </Button>
                      </Col>
                    )}
                  {tipoAcao &&
                    tipoAcao.excluirRequerimento &&
                    permissaoCancelarRequerimentos && (
                      <Col lg="12">
                        <Button
                          color="danger"
                          onClick={handleCancelarRequerimentos}
                        >
                          Cancelar Requerimentos
                        </Button>
                      </Col>
                    )}
                </Row>
              </CardBody>
            </Card>
          </div>
        )}
        {item_requerimento != null &&
          item_requerimento.setupSolicitacaoAcao.setupSolicitacao.segmento ===
          "Transportador" && (
            <FichaRequerimentoTransportador
              item={item_requerimento}
              handleReturn={handleReturn}
              showAcoesGestor={true}
            />
          )}
        {item_requerimento != null &&
          (item_requerimento.setupSolicitacaoAcao.setupSolicitacao.segmento ===
            "Grande Gerador" ||
            item_requerimento.setupSolicitacaoAcao.setupSolicitacao.segmento ===
            "Grande Gerador - PGRCC") && (
            <FichaRequerimentoGerador
              item={item_requerimento}
              handleReturn={handleReturn}
              showAcoesGestor={true}
            />
          )}
        {item_requerimento != null &&
          item_requerimento.setupSolicitacaoAcao.setupSolicitacao.segmento ===
          "Destino Final" && (
            <FichaRequerimentoDestino
              item={item_requerimento}
              handleReturn={handleReturn}
              showAcoesGestor={true}
            />
          )}
      </div>
    </>
  );
}
